import mediator from '../utilities/mediator';
import log from '../utilities/log';

import { Organization } from '../models';
import {
  mutationOptions,
  queryOptions,
  UseMutationOptions,
  UseQueryOptions,
} from '@tanstack/react-query';
import { EntityState } from 'adc-sirius-module-common';

type OrganizationQueryParams = {
  key?: string;
};

type OrganizationsQueryParams = {
  state?: EntityState;
};

type CreateOrganizationVariables = {
  organization: Organization;
};

export function organizationsQueryOptions(
  params: OrganizationsQueryParams = {},
  options?: Partial<UseQueryOptions<Organization[]>>,
) {
  return queryOptions<Organization[]>({
    ...options,
    queryKey: ['organizations'],
    queryFn: async () => {
      try {
        return await mediator.request<Organization[]>(
          'organization:getOrganizations',
          { ...params },
        );
      } catch (error) {
        log.error(error);
        throw error;
      }
    },
  });
}

export function organizationQueryOptions(
  params: OrganizationQueryParams,
  options?: Partial<UseQueryOptions<Organization>>,
) {
  return queryOptions<Organization>({
    ...options,
    queryKey: ['organization', params],
    queryFn: async () => {
      try {
        return await mediator.request<Organization>(
          'organization:getOrganizationByKey',
          {
            ...params,
          },
        );
      } catch (error) {
        log.error(error);
        throw error;
      }
    },
    enabled: !!params?.key,
  });
}

export function createOrganizationMutateOptions(
  options?: Partial<
    UseMutationOptions<Organization, Error, CreateOrganizationVariables>
  >,
) {
  return mutationOptions<Organization, Error, CreateOrganizationVariables>({
    ...options,
    mutationFn: async ({ organization }: CreateOrganizationVariables) => {
      try {
        return await mediator.request<Organization>(
          'organization:createOrganization',
          {
            data: organization,
          },
        );
      } catch (error) {
        log.error(error);
        throw error;
      }
    },
  });
}
